import { Controller } from '@hotwired/stimulus';

export default class ConfirmationButtonController extends Controller {
  static targets = [
    'answerTextField',
    'confirmButton'
  ];

  connect() {
    this.toggleDisabled();
  }

  toggleDisabled() {
    const disabled = this.answerTextFieldTargets.some((field) => {
      return field.value === '';
    });

    for (const button of this.confirmButtonTargets) {
      button.disabled = disabled;
    }
  }
}
